import { topics } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200 border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            51吃瓜今日黑料最火话题标签，点击探索更多劲爆内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.id}
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${colorMap[topic.color] || colorMap.primary}`}
            >
              <i className="ri-hashtag text-base"></i>
              {topic.name}
              <span className="text-xs opacity-60 ml-1">{topic.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}